// UK Sort Code to Bank mapping and IBAN calculation
// Ported from scouting-app-api/apps/api/common/iban/services.py

/* eslint-disable quote-props */
const UK_KNOWN_SORT_CODES: Record<string, { name: string; bic: string; bankCode: string }> = {
  200000: { name: "Barclays Bank", bic: "BARCGB22", bankCode: "BARC" },
  203253: { name: "Barclays Bank", bic: "BARCGB22", bankCode: "BARC" },
  202678: { name: "Barclays Bank", bic: "BARCGB22", bankCode: "BARC" },
  204660: { name: "Barclays Bank UK", bic: "BUKBGB22", bankCode: "BUKB" },
  400328: { name: "HSBC Bank", bic: "MIDLGB22", bankCode: "MIDL" },
  401276: { name: "HSBC Bank", bic: "MIDLGB22", bankCode: "MIDL" },
  404218: { name: "HSBC UK Bank", bic: "HBUKGB4B", bankCode: "HBUK" },
  300000: { name: "Lloyds Bank", bic: "LOYDGB21", bankCode: "LOYD" },
  309542: { name: "Lloyds Bank", bic: "LOYDGB21", bankCode: "LOYD" },
  774926: { name: "Lloyds Bank", bic: "LOYDGB21", bankCode: "LOYD" },
  560005: { name: "NatWest", bic: "NWBKGB2L", bankCode: "NWBK" },
  600001: { name: "NatWest", bic: "NWBKGB2L", bankCode: "NWBK" },
  606004: { name: "NatWest", bic: "NWBKGB2L", bankCode: "NWBK" },
  "090128": { name: "Santander UK", bic: "ABBYGB2L", bankCode: "ABBY" },
  "090000": { name: "Santander UK", bic: "ABBYGB2L", bankCode: "ABBY" },
  "070030": { name: "Nationwide Building Society", bic: "NAIAGB21", bankCode: "NAIA" },
  "070436": { name: "Nationwide Building Society", bic: "NAIAGB21", bankCode: "NAIA" },
  110001: { name: "Halifax", bic: "HABORV21", bankCode: "HLFX" },
  120103: { name: "Bank of Scotland", bic: "BOFSGB21", bankCode: "BOFS" },
  166300: { name: "Royal Bank of Scotland", bic: "RBSSGB2L", bankCode: "RBSS" },
  161602: { name: "Royal Bank of Scotland", bic: "RBSSGB2L", bankCode: "RBSS" },
  "040004": { name: "Monzo Bank", bic: "MONZGB2L", bankCode: "MONZ" },
  "040048": { name: "Starling Bank", bic: "SRLGGB2L", bankCode: "SRLG" },
  "040059": { name: "Starling Bank", bic: "SRLGGB2L", bankCode: "SRLG" },
  608371: { name: "Starling Bank", bic: "SRLGGB2L", bankCode: "SRLG" },
  "040075": { name: "Modulr Finance (Revolut)", bic: "MODRGB21", bankCode: "MODR" },
  "040026": { name: "N26 Bank", bic: "NTSBDEB1", bankCode: "NTSB" },
  231470: { name: "Wise", bic: "TRWIGB2L", bankCode: "TRWI" },
  230580: { name: "Metro Bank", bic: "MYMBGB2L", bankCode: "MYMB" },
  236972: { name: "Prepay Technologies", bic: "PABORV22", bankCode: "PPAY" },
  "089249": { name: "Co-operative Bank", bic: "CPBKGB22", bankCode: "CPBK" },
  "087199": { name: "APS Financial", bic: "LOYDGB21", bankCode: "LOYD" },
  "083210": { name: "HMRC", bic: "BABORV22", bankCode: "HMRC" },
  180002: { name: "Coutts", bic: "CABORV22", bankCode: "COUT" },
  185008: { name: "Citibank", bic: "CIABORV1", bankCode: "CITI" },
  165050: { name: "Bank of America", bic: "BABORV22", bankCode: "BOFA" },
  609104: { name: "Standard Chartered", bic: "SCBLGB2L", bankCode: "SCBL" },
  826138: { name: "Virgin Money", bic: "NABORV21", bankCode: "NRNB" }
}
/* eslint-enable quote-props */

const UK_SORT_CODE_PREFIXES: Record<string, { name: string; bic: string; bankCode: string }> = {
  20: { name: "Barclays Bank", bic: "BARCGB22", bankCode: "BARC" },
  30: { name: "Lloyds Bank", bic: "LOYDGB21", bankCode: "LOYD" },
  40: { name: "HSBC", bic: "MIDLGB22", bankCode: "MIDL" },
  56: { name: "NatWest", bic: "NWBKGB2L", bankCode: "NWBK" },
  60: { name: "NatWest", bic: "NWBKGB2L", bankCode: "NWBK" },
  80: { name: "Bank of Scotland", bic: "BOFSGB21", bankCode: "BOFS" },
  "09": { name: "Santander UK", bic: "ABBYGB2L", bankCode: "ABBY" },
  "07": { name: "Nationwide", bic: "NAIAGB21", bankCode: "NAIA" },
  "04": { name: "Monzo/Starling", bic: "MONZGB2L", bankCode: "MONZ" },
  23: { name: "Metro Bank", bic: "MYMBGB2L", bankCode: "MYMB" },
  82: { name: "Clydesdale Bank", bic: "CLYDGB21", bankCode: "CLYD" },
  11: { name: "Halifax", bic: "HABORV21", bankCode: "HLFX" },
  12: { name: "Bank of Scotland", bic: "BOFSGB21", bankCode: "BOFS" },
  16: { name: "Royal Bank of Scotland", bic: "RBSSGB2L", bankCode: "RBSS" },
  77: { name: "Lloyds Bank", bic: "LOYDGB21", bankCode: "LOYD" },
  "08": { name: "Co-operative Bank", bic: "CPBKGB22", bankCode: "CPBK" },
  18: { name: "Coutts/Citibank", bic: "CABORV22", bankCode: "COUT" }
}

function getUkBankFromSortCode(sortCode: string): { name: string; bic: string; bankCode: string } {
  if (UK_KNOWN_SORT_CODES[sortCode]) return UK_KNOWN_SORT_CODES[sortCode]
  const prefix = sortCode.slice(0, 2)
  if (UK_SORT_CODE_PREFIXES[prefix]) return UK_SORT_CODE_PREFIXES[prefix]
  return { name: "", bic: "", bankCode: "XXXX" }
}

function calculateUkIban(sortCode: string, accountNumber: string, bankCode: string): string {
  const bban = `${bankCode}${sortCode}${accountNumber}`
  const checkString = `${bban}GB00`

  let numeric = ""
  for (const char of checkString) {
    if (char >= "0" && char <= "9") {
      numeric += char
    } else {
      numeric += (char.charCodeAt(0) - 55).toString()
    }
  }

  // BigInt for mod-97 calculation
  const checkDigits = 98n - (BigInt(numeric) % 97n)
  const checkDigitsStr = checkDigits.toString().padStart(2, "0")

  const iban = `GB${checkDigitsStr}${bban}`
  return iban.replace(/(.{4})/g, "$1 ").trim()
}

export function lookupUkBank(sortCode: string, accountNumber: string): {
  bankName: string
  bic: string
  iban: string
} | null {
  const cleanSort = sortCode.replace(/-/g, "")
  if (cleanSort.length !== 6 || accountNumber.length !== 8) return null

  const bankInfo = getUkBankFromSortCode(cleanSort)
  const iban = calculateUkIban(cleanSort, accountNumber, bankInfo.bankCode)

  return {
    bankName: bankInfo.name,
    bic: bankInfo.bic,
    iban
  }
}
